export default function storeCustomerData(value) {

    return dispatch => dispatch({
        type: 'SAVE_CUSTOMERDATA_FULFILLED',
        payload: value
    });
}


// WEBPACK FOOTER //
// ./src/actions/VXC/storeCustomerData.js